import { Navbar } from '@/components/Navbar';
import { ScrollProgress } from '@/components/ScrollProgress';
import { HeroSection } from '@/components/HeroSection';
import { ProgramOverview } from '@/components/ProgramOverview';
import { TierShowcase } from '@/components/TierShowcase';
import { EarnSection } from '@/components/EarnSection';
import { RedeemSection } from '@/components/RedeemSection';
import { BadgesSection } from '@/components/BadgesSection';
import { FamilySection } from '@/components/FamilySection';
import { PointsCalculator } from '@/components/PointsCalculator';
import { CTASection } from '@/components/CTASection';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';

export default function RewardsLanding() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollProgress />
      <Navbar />
      <main>
        <HeroSection />
        <ProgramOverview />
        <TierShowcase />
        <EarnSection />
        <RedeemSection />
        <BadgesSection />
        <FamilySection />
        <PointsCalculator />
        <CTASection />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          className: 'bg-card border-border text-foreground font-body',
        }}
      />
    </div>
  );
}
